'use client';
import Script from 'next/script';
import { useEffect } from 'react';

export function ChatWidget() {
  function handleOpen(e) {
    if (!e?.isTrusted) return;
    if (
      e?.isTrusted &&
      e?.origin == 'https://chatwidget.kodif.ai' &&
      e?.data?.isExpanded == true
    ) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'zendeskChatOpened' });
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleOpen, true);
    return () => {
      window.removeEventListener('message', handleOpen, true);
    };
  }, []);

  return (
    <Script
      id="kodif-widget"
      src="https://autopilot.kodif.io/chat/v1/application/1451b640-6b06-4ce5-8f27-1fc3f7f21ea1/widget-script"
    />
  );
}
